export const Constants = {
  TEST_PHONE_NUMBER: "+31241111111",
};
